import {
  useEffect, useRef, useState
} from 'react';
import useSWR from 'swr';

import keycloakService from '../../keycloak_service';
import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

const fetchFromSinatra = (queryParams) => {
  const [workspaceId, pipelineName, sinatraEndpoint] = queryParams;
  const workspaceIdAsNum = Number(workspaceId);
  const params = {
    workspace_id: workspaceIdAsNum,
    pipeline_name: pipelineName,
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(params),
  };

  return postToApi(sinatraEndpoint, fetchOptions);
}

export const usePipelineExternalUrl = (workspaceId, pipelineName) => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const { data: externalUrlData, error } = useSWR(
    [workspaceId, pipelineName, 'v1/api/admin/get_pipeline_external_url'],
    fetchFromSinatra
  );

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    externalUrl: externalUrlData?.url,
    error: errorMessage,
  };
};

export const usePipelineInternalUrl = (workspaceId, pipelineName) => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const { data: internalUrlData, error } = useSWR(
    [workspaceId, pipelineName, 'v1/api/admin/get_pipeline_internal_url'],
    fetchFromSinatra
  );

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    internalUrl: internalUrlData?.url,
    error: errorMessage,
  };
};
